import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enPh from './locales/en_ph.json';

const i18nOptions = {
  resources: {
    en: { translation: enPh },
  },
  fallbackLng: 'en',
  lng: 'en',
  interpolation: { escapeValue: false },
};

i18n.use(initReactI18next).init(i18nOptions);

export default i18n;
